/**
 * Client-side Logger
 *
 * Centralizes all console output with automatic dev-gating:
 * - debug/info/warn: development only (eliminated in production builds)
 * - error: always logged
 *
 * Usage:
 *   import { logger } from '@/application/core';
 *   logger.debug('MyComponent', 'mounted with props', props);
 *   logger.error('MyHook', 'Fetch failed:', err);
 */

const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  debug(tag: string, message: string, ...args: unknown[]) {
    if (isDev) console.debug(`[${tag}]`, message, ...args);
  },

  info(tag: string, message: string, ...args: unknown[]) {
    if (isDev) console.info(`[${tag}]`, message, ...args);
  },

  warn(tag: string, message: string, ...args: unknown[]) {
    if (isDev) console.warn(`[${tag}]`, message, ...args);
  },

  error(tag: string, message: string, ...args: unknown[]) {
    console.error(`[${tag}]`, message, ...args);
  },
};
